module.exports = __webpack_public_path__ + "static/017_001-a0e0b619e568fd96962a43ff634e5223.jpg";